import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_020",
  "use": "icon-su_020-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-su_020\"><defs><style>#icon-su_020 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_020_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_020_icon\"><rect class=\"cls-1\" width=\"16\" height=\"16\" /><polygon class=\"cls-2\" points=\"8 10.71 3.65 6.35 4.35 5.65 8 9.29 11.65 5.65 12.35 6.35 8 10.71\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol